import React from "react";
import { ImageDataType } from "../../../commonTypes/fileManagerTypes";
import Files from "./Files";
import { TableHeader } from "../../commons";
import { childFolderType } from "../../../redux/fileManager/fileManagerTypes";
import FileFolderTableViewData from "./FileTableViewData";

const fileTableHeader = [
  {
    label: "NAME",
    value: "name",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "UPDATED BY",
    value: "updated_by",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "UPDATED ON",
    value: "uploaded_on",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Action",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
];
type AppProps = {
  type?: string;
  document: any;
  showDeleteIcon: boolean;
  handleToggleViewMoreFiles?: () => void;
  toggleRenameFileModal?: () => void;
  handleSetViewMoreFileId?: (file_id: number | null | undefined) => void;
  showViewMoreFiles: boolean;
  viewMoreFileId?: number | null | undefined;
  handleSetFileRenameModalData?: (data: any) => void;
  isRenameFilePresent: boolean;
  multipleFileData?: any;
  setMultipleFileData?: any;
  filesData?: any;
  setFilesData?: any;
  uploadData?: any;
  removingFileData?: (data: string) => void;
  getImageDetails?: (url: ImageDataType) => void;
  handleUploadInvoiceFile?: (
    finalFileName: string,
    fileUrl: string,
    fileType: string
  ) => void;
  childFiles?: any;
  tableView: boolean;

  flag?: boolean;
  setFlag?: (data: boolean) => void;

  folder?: childFolderType;
  folderId?: number;
  client_code?: string | number | null;
  history?: any;
  company_name?: string;
  viewMoreFolderId?: number | null | undefined;
  showViewMore: boolean;
  handleToggleViewMore?: () => void;
  handleSetViewMoreFolderId?: (folder_id: number | null | undefined) => void;
  handleSetRenameModalData?: (folderData: childFolderType) => void;
  toggleRenameFolderModal?: () => void;
  isRenameFolderPresent?: boolean;
  setSingleFolderData?: any;
  singleFolderData?: any;
  persistFolderData?: any;
  setPersistFolderData?: any;
  setCheckingBack?: React.Dispatch<React.SetStateAction<boolean>>;
  checkingBack?: boolean;
  setSearchData?: React.Dispatch<React.SetStateAction<string>>;
  setShowSearchData?: React.Dispatch<React.SetStateAction<string>>;
  setShowViewMoreFiles: React.Dispatch<React.SetStateAction<boolean>>;
  childFolders: any;
  handleDeleteFileAndFolder?: (folderData: childFolderType) => void;
  isFileAndFolderDelete?: boolean;
  handleHideFileFolder?:(data:childFolderType)=>void;
  handleUnHideFileFolder?:(data:childFolderType)=>void;
  isHideAndShowFileFolderPresent?:boolean;
  isParrentHide:number|null;
};
const FilesMap = React.memo(
  ({
    showDeleteIcon,
    handleToggleViewMoreFiles,
    handleSetViewMoreFileId,
    showViewMoreFiles,
    viewMoreFileId,
    toggleRenameFileModal,
    isRenameFilePresent,
    handleSetFileRenameModalData,
    getImageDetails,
    childFiles,
    tableView,
    client_code,
    company_name,
    showViewMore,
    handleToggleViewMore,
    handleSetViewMoreFolderId,
    viewMoreFolderId,
    handleSetRenameModalData,
    toggleRenameFolderModal,
    isRenameFolderPresent,
    setSearchData,
    setShowSearchData,
    childFolders,
    setShowViewMoreFiles,
    handleDeleteFileAndFolder,
    isFileAndFolderDelete,
    handleHideFileFolder,
    handleUnHideFileFolder,
    isHideAndShowFileFolderPresent,
    isParrentHide
  }: AppProps) => {
    const showFilesData = () => {
      let finalDocumentList =
        childFiles?.length > 0 &&
        childFiles?.map((document: any) => {
          return (
            <Files
            isParrentHide={isParrentHide}
            documentFile={document}
              showDeleteIcon={showDeleteIcon}
              handleToggleViewMoreFiles={handleToggleViewMoreFiles}
              handleSetViewMoreFileId={handleSetViewMoreFileId}
              showViewMoreFiles={showViewMoreFiles}
              toggleRenameFileModal={toggleRenameFileModal}
              viewMoreFileId={viewMoreFileId}
              handleSetFileRenameModalData={handleSetFileRenameModalData}
              isRenameFilePresent={isRenameFilePresent}
              getImageDetails={getImageDetails}
              setShowViewMoreFiles={setShowViewMoreFiles}
              handleDeleteFileAndFolder={handleDeleteFileAndFolder}
              isFileAndFolderDelete={isFileAndFolderDelete}
              handleHideFileFolder={handleHideFileFolder}
              handleUnHideFileFolder={handleUnHideFileFolder}
              isHideAndShowFileFolderPresent={isHideAndShowFileFolderPresent}
            />
          );
        });

      return finalDocumentList;
    };
    const showFilesinGridData = () => {
      return (
        <div style={{ width: "100%" }}>
          <div className="table-bordered disbursment">
            <table className="table table">
              <thead className=" sticky-table-header">
                <TableHeader tableHeader={fileTableHeader} />
              </thead>
              <tbody>
                <FileFolderTableViewData
                  tableHeader={fileTableHeader}
                  isParrentHide={isParrentHide}
                  childFiles={childFiles}
                  handleToggleViewMoreFiles={handleToggleViewMoreFiles}
                  handleSetViewMoreFileId={handleSetViewMoreFileId}
                  toggleRenameFileModal={toggleRenameFileModal}
                  showViewMoreFiles={showViewMoreFiles}
                  viewMoreFileId={viewMoreFileId}
                  handleSetFileRenameModalData={handleSetFileRenameModalData}
                  //////

                  childFolders={childFolders}
                  // key={childFolder.id}
                  // 			folder={childFolder}
                  client_code={client_code}
                  company_name={company_name}
                  viewMoreFolderId={viewMoreFolderId}
                  handleToggleViewMore={handleToggleViewMore}
                  handleSetViewMoreFolderId={handleSetViewMoreFolderId}
                  showViewMore={showViewMore}
                  handleSetRenameModalData={handleSetRenameModalData}
                  toggleRenameFolderModal={toggleRenameFolderModal}
                  isRenameFolderPresent={isRenameFolderPresent}
                  setSearchData={setSearchData}
                  setShowSearchData={setShowSearchData}
                  getImageDetails={getImageDetails}
                  setShowViewMoreFiles={setShowViewMoreFiles}
                  handleDeleteFileAndFolder={handleDeleteFileAndFolder}
                  isFileAndFolderDelete={isFileAndFolderDelete}
                  handleHideFileFolder={handleHideFileFolder}
                  handleUnHideFileFolder={handleUnHideFileFolder}
                  isHideAndShowFileFolderPresent={isHideAndShowFileFolderPresent}
                />
              </tbody>
            </table>
          </div>
        </div>
      );
    };
    return <>{!tableView ? showFilesData() : showFilesinGridData()}</>;
  }
);

export default FilesMap;
